module.exports = __webpack_public_path__ + "img/supplyChain.8bc803dd.png";